// extracted by mini-css-extract-plugin
export default {"container":"Header_container__vI36D","header":"Header_header__HXQOm","logo_block":"Header_logo_block__u2jsK","logo":"Header_logo__UsziS"};